/// <reference path='../../../../../typings/index.d.ts' />
/// <reference path='../../../components/baseClasses/dataMaintenanceSectionBase.ts' />

module Meevo.Plugins.MarketPricing {
    'use strict';

    import IPagedResultsColumns = Meevo.Components.BaseClasses.IPagedResultsColumns;
    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;

    export class DiscountsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        public entityTypes: Array<any>;
        public discountTypes: Array<any>;
        public showFilteredItems: boolean = false;
        private isDefaultMarket: boolean = false;
        public filterCriteria: any = {
            discountEntityTypeEnum: null,
            discountTypeEnum: null,
            priceGroupId: '',
        };

        constructor(protected params: Meevo.Model.ISectionParamsMarketPrice) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.entityTypes = _.values(this.params.discountsService.entityTypes);
            this.entityTypes.unshift({
                id: null,
                displayName: 'All'
            });
            this.discountTypes = _.values(this.params.discountsService.discountTypes);
            this.discountTypes.unshift({
                id: null,
                displayName: 'All'
            });
        }

        public get discountTypeEnum(): any {
            return DiscountTypeEnum;
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {

            this.postCancel();
            this.takeBackup();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            // Only a tab load hands over the market itself; a save hands over its empty response.
            if (_.has(this.model, 'isDefault')) {
                this.isDefaultMarket = this.model['isDefault'];
            }

            this.postCancel();
        }

        /**
         * When tab is deactivated
         * */
        public prevUnselected(): void {
            this.sectionEndpoint = '';

            super.prevUnselected();
        }

        public defaultCriteria() {
            return this.filterCriteria;
        }

        public postCancel(): void {

            this.filterCriteria.priceGroupId = this.parentItemId;
            this.filterCriteria.discountEntityTypeEnum = null;
            this.filterCriteria.discountTypeEnum = null;
        }

        /**
         * Save
         * */
        public preSave(): any {
            this.sectionEndpoint = 'Discount';

            let currentPage = this.model.pages[this.model.currentPage];
            let originalEntity = this.originalEntity;
            let originalCurrentPage = originalEntity.pages[this.model.currentPage];
            let save = {
                models: []
            };

            // Find changed items
            _.each(currentPage, (element: any, index) => {
                if (element.discountAmount !== originalCurrentPage[index].discountAmount) {
                    save.models.push({
                        discountId: element.discountId,
                        discountAmount: element.discountAmount,
                    });
                }
            });

            this.model = <IPagerModel>save;
        }

        public showRevertToDefault(item: any): boolean {
            return !this.isDefaultMarket
                && Meevo.Model.Guard.isSomething(item.defaultDiscountAmount, false)
                && item.discountAmount != item.defaultDiscountAmount;
        }

        public revertToDefault(item: any): void {
            item.discountAmount = item.defaultDiscountAmount;
        }

        discountTypesTranslate(el: DiscountTypeEnum) {
            let discountType: any = _.findWhere(this.discountTypes, {id: el});
            return discountType.displayName;
        }
    }
}